module.exports = __webpack_public_path__ + "static/media/exitfund.d399bb4f.svg";